import React, { useState, useEffect } from "react";
import { Box, Fade } from "@chakra-ui/react";
import SalesTeam from "../components/sales/SalesTeam";
import { hasSingleProjectAccess } from "../utils/auth";

const SalesTeamPage: React.FC = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const isSingleProject = hasSingleProjectAccess();
  
  useEffect(() => {
    // Trigger page fade animation
    setIsLoaded(true);
  }, []);
  
  return (
    <Fade 
      in={isLoaded} 
      transition={{ enter: { duration: 0.3 } }}
    >
      <Box height="100%" width="100%">
        <SalesTeam hideProjectFilter={isSingleProject} />
      </Box>
    </Fade>
  );
};

export default SalesTeamPage; 